import { gql } from '@apollo/client';

const UPDATE_PERSON = gql`
  mutation UpdatePerson(
    $uuid: ID
    $firstName: String!
    $lastName: String!
    $middleName: String
    $nickname: String
    $about: String
    $profileImage: Upload
    $avatar: String
    $birthdate: Date
  ) {
    updatePerson(
      person: {
        uuid: $uuid
        firstName: $firstName
        lastName: $lastName
        nickname: $nickname
        about: $about
        profileImage: $profileImage
        middleName: $middleName
        avatar: $avatar
        birthdate: $birthdate
      }
    ) {
      success
      errors
      person {
        uuid
        fullName
        firstName
        lastName
        middleName
        nickname
        about
        birthdate
        suffix
        title
        profileImageUrl
        avatar
      }
    }
  }
`;
const ADD_PERSON_EMAIL = gql`
  mutation AddPersonEmail(
    $personId: ID!
    $isPrimary: Boolean
    $emailAddress: String
    $showInDirectory: Boolean
  ) {
    addPersonEmail(
      email: {
        personId: $personId
        isPrimary: $isPrimary
        emailAddress: $emailAddress
        showInDirectory: $showInDirectory
      }
    ) {
      success
      errors
      email {
        id
        emailAddress
        isVerified
        showInDirectory
        isPrimary
      }
    }
  }
`;
const UPDATE_PERSON_EMAIL = gql`
  mutation UpdatePersonEmail(
    $id: ID!
    $personId: ID!
    $isPrimary: Boolean
    $showInDirectory: Boolean
    $emailAddress: String
  ) {
    updatePersonEmail(
      email: {
        id: $id
        personId: $personId
        isPrimary: $isPrimary
        showInDirectory: $showInDirectory
        emailAddress: $emailAddress
      }
    ) {
      success
      errors
      email {
        id
        emailAddress
        isVerified
        showInDirectory
        isPrimary
      }
    }
  }
`;
const DELETE_PERSON_EMAIL = gql`
  mutation DeletePersonEmail($personId: ID, $id: ID!) {
    deletePersonEmail(email: { personId: $personId, id: $id }) {
      success
      errors
    }
  }
`;

const ADD_PERSON_PHONE = gql`
  mutation AddPersonPhone(
    $phoneNumber: String!
    $personId: ID!
    $textMeHere: Boolean
    $showInDirectory: Boolean
    $categoryId: ID!
  ) {
    addPhone(
      phone: {
        categoryId: $categoryId
        phoneNumber: $phoneNumber
        personId: $personId
        showInDirectory: $showInDirectory
        textMeHere: $textMeHere
      }
    ) {
      success
      errors
      phone {
        id
        phoneNumber
        showInDirectory
        textMeHere
        phoneCategory {
          id
          phoneCategory
        }
      }
    }
  }
`;
const UPDATE_PERSON_PHONE = gql`
  mutation UpdatePersonPhone(
    $id: ID!
    $personId: ID!
    $phoneNumber: String!
    $categoryId: ID!
    $showInDirectory: Boolean
    $textMeHere: Boolean
  ) {
    updatePhone(
      phone: {
        categoryId: $categoryId
        phoneNumber: $phoneNumber
        id: $id
        personId: $personId
        showInDirectory: $showInDirectory
        textMeHere: $textMeHere
      }
    ) {
      success
      errors
      phone {
        id
        phoneNumber
        showInDirectory
        textMeHere
        phoneCategory {
          id
          phoneCategory
        }
      }
    }
  }
`;
const DELETE_PERSON_PHONE = gql`
  mutation DeletePersonPhone(
    $id: ID!
    $personId: ID!
    $categoryId: ID!
    $phoneNumber: String!
  ) {
    deletePhone(
      phone: {
        phoneNumber: $phoneNumber
        id: $id
        personId: $personId
        categoryId: $categoryId
      }
    ) {
      success
      errors
    }
  }
`;
const ADD_PERSON_SOCIAL_MEDIA = gql`
  mutation AddSocialMedia(
    $personId: ID!
    $categoryId: ID!
    $showInDirectory: Boolean
    $username: String!
  ) {
    addSocialMedia(
      socialMedia: {
        categoryId: $categoryId
        personId: $personId
        showInDirectory: $showInDirectory
        username: $username
      }
    ) {
      success
      errors
      socialMedia {
        id
        socialMediaCategory {
          id
          name
          url
        }
        username
        url
        showInDirectory
      }
    }
  }
`;
const UPDATE_PERSON_SOCIAL_MEDIA = gql`
  mutation UpdateSocialMedia(
    $id: ID!
    $personId: ID!
    $categoryId: ID!
    $username: String!
    $showInDirectory: Boolean
  ) {
    updateSocialMedia(
      socialMedia: {
        id: $id
        personId: $personId
        categoryId: $categoryId
        username: $username
        showInDirectory: $showInDirectory
      }
    ) {
      success
      errors
      socialMedia {
        id
        username
        url
        showInDirectory
        socialMediaCategory {
          id
          name
          url
        }
      }
    }
  }
`;
const DELETE_PERSON_SOCIAL_MEDIA = gql`
  mutation DeleteSocialMedia($id: ID!, $categoryId: ID!, $personId: ID!) {
    deleteSocialMedia(
      socialMedia: { id: $id, categoryId: $categoryId, personId: $personId }
    ) {
      success
      errors
    }
  }
`;
const ADD_PERSON_ADDRESS = gql`
  mutation AddNewAddress(
    $addressLine1: String
    $addressLine2: String
    $addressLine3: String
    $attention: String
    $city: String
    $postalCode: String
    $zone: String
    $name: String
    $personUuid: ID!
    $showInDirectory: Boolean
    $thirdPartyAddress: Boolean
    $regionId: ID!
    $categoryId: ID!
    $isOrg: Boolean
  ) {
    addAddress(
      address: {
        regionId: $regionId
        addressLine1: $addressLine1
        addressLine2: $addressLine2
        addressLine3: $addressLine3
        attention: $attention
        city: $city
        postalCode: $postalCode
        zone: $zone
        categoryId: $categoryId
        isOrg: $isOrg
      }
      addressEntity: {
        name: $name
        personUuid: $personUuid
        showInDirectory: $showInDirectory
        thirdPartyAddress: $thirdPartyAddress
      }
    ) {
      success
      errors
      addressEntity {
        uuid
        thirdPartyAddress
        showInDirectory
        name
        locationPhotoUrl
        address {
          uuid
          attention
          addressLine1
          addressLine2
          addressLine3
          city
          zone
          postalCode
          summary
          region {
            id
            name
            globalRegion
            label
            worldRegion
          }
          category {
            id
            name
            description
          }
          isOrg
          coordinates
        }
      }
    }
  }
`;
const UPDATE_PERSON_ADDRESS = gql`
  mutation UpdateAddress(
    $uuid: ID!
    $thirdPartyAddress: Boolean
    $showInDirectory: Boolean
    $personUuid: ID!
    $orgUuid: ID
    $name: String
    $addressId: ID!
    $addressLine1: String
    $addressLine2: String
    $addressLine3: String
    $attention: String
    $categoryId: ID!
    $city: String
    $isOrg: Boolean
    $postalCode: String
    $regionId: ID!
    $zone: String
  ) {
    updateAddress(
      addressEntity: {
        uuid: $uuid
        thirdPartyAddress: $thirdPartyAddress
        showInDirectory: $showInDirectory
        personUuid: $personUuid
        orgUuid: $orgUuid
        name: $name
      }
      address: {
        regionId: $regionId
        categoryId: $categoryId
        addressId: $addressId
        addressLine1: $addressLine1
        addressLine2: $addressLine2
        addressLine3: $addressLine3
        attention: $attention
        city: $city
        isOrg: $isOrg
        postalCode: $postalCode
        zone: $zone
      }
    ) {
      success
      errors
      addressEntity {
        uuid
        thirdPartyAddress
        showInDirectory
        name
        locationPhotoUrl
        address {
          uuid
          attention
          addressLine1
          addressLine2
          addressLine3
          city
          zone
          postalCode
          summary
          region {
            id
            name
            globalRegion
            label
            worldRegion
          }
          category {
            id
            name
            description
          }
          isOrg
          coordinates
        }
      }
    }
  }
`;
const DELETE_PERSON_ADDRESS = gql`
  mutation DeleteAddress($uuid: ID!) {
    deleteAddress(addressEntity: { uuid: $uuid }) {
      success
      errors
    }
  }
`;
const MANAGE_SETTINGS = gql`
  mutation ManageSettings(
    $id: ID
    $disableMessaging: Boolean
    $doNotContact: Boolean
    $promoFrequency: Int
    $emailOptIn: Boolean
    $emailPrefId: ID
    $phoneOptIn: Boolean
    $phonePrefId: ID
    $promoPhoneOptIn: Boolean
    $promoPushOptIn: Boolean
    $promoSmsOptIn: Boolean
    $pushOptIn: Boolean
    $serviceEmailOptIn: Boolean
    $servicePhoneOptIn: Boolean
    $servicePushOptIn: Boolean
    $serviceSmsOptIn: Boolean
    $smsOptIn: Boolean
    $smsPrefId: ID
    $smsPromoPrefId: ID
    $eventRemindersOptIn: Boolean
  ) {
    manageSettings(
      servicePreference: {
        id: $id
        disableMessaging: $disableMessaging
        doNotContact: $doNotContact
        promoFrequency: $promoFrequency
        emailOptIn: $emailOptIn
        emailPrefId: $emailPrefId
        phoneOptIn: $phoneOptIn
        phonePrefId: $phonePrefId
        promoPhoneOptIn: $promoPhoneOptIn
        promoPushOptIn: $promoPushOptIn
        promoSmsOptIn: $promoSmsOptIn
        pushOptIn: $pushOptIn
        serviceEmailOptIn: $serviceEmailOptIn
        servicePhoneOptIn: $servicePhoneOptIn
        servicePushOptIn: $servicePushOptIn
        serviceSmsOptIn: $serviceSmsOptIn
        smsOptIn: $smsOptIn
        smsPrefId: $smsPrefId
        smsPromoPrefId: $smsPromoPrefId
        eventRemindersOptIn: $eventRemindersOptIn
      }
    ) {
      success
      errors
      publicKey
      servicePreference {
        id
        doNotContact
        promoFrequency
        disableMessaging
        emailOptIn
        emailPref {
          id
          emailAddress
          isVerified
          isPrimary
          showInDirectory
        }
        emailSubscription {
          id
          status
          confirmedAt
          createdAt
        }
        serviceEmailOptIn
        phoneOptIn
        phonePref {
          id
          phoneNumber
          showInDirectory
          textMeHere
          phoneCategory {
            id
            phoneCategory
          }
        }
        promoPhoneOptIn
        servicePhoneOptIn
        smsOptIn
        serviceSmsOptIn
        promoSmsOptIn
        eventRemindersOptIn
        smsPref {
          id
          phoneNumber
          showInDirectory
          textMeHere
          phoneCategory {
            id
            phoneCategory
          }
        }
        smsPromoPref {
          id
          textMeHere
          showInDirectory
          phoneNumber
          phoneCategory {
            id
            phoneCategory
          }
        }
        promoPushOptIn
        pushOptIn
        servicePushOptIn
      }
    }
  }
`;
const UPDATE_MY_PREFS = gql`
  mutation UpdatedMyPrefs($themePref: String, $tzPref: String) {
    updateSbuUserSettings(themePref: $themePref, tzPref: $tzPref) {
      success
      errors
      sbuUser {
        id
        themePref
        tzPref
      }
    }
  }
`;
export {
  UPDATE_PERSON,
  ADD_PERSON_EMAIL,
  DELETE_PERSON_EMAIL,
  UPDATE_PERSON_EMAIL,
  ADD_PERSON_PHONE,
  UPDATE_PERSON_PHONE,
  DELETE_PERSON_PHONE,
  ADD_PERSON_SOCIAL_MEDIA,
  UPDATE_PERSON_SOCIAL_MEDIA,
  DELETE_PERSON_SOCIAL_MEDIA,
  ADD_PERSON_ADDRESS,
  UPDATE_PERSON_ADDRESS,
  DELETE_PERSON_ADDRESS,
  MANAGE_SETTINGS,
  UPDATE_MY_PREFS,
};
